import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import tagService from "./tagsService";

export const getTags = createAsyncThunk(
    "productTag/get-tags",
    async (thunkAPI) => {
        try {
            return await tagService.getTags();
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const createTag = createAsyncThunk(
    "productTag/create-tag",
    async (tagData, thunkAPI) => {
        try {
            return await tagService.createTag(tagData);
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const updateTag = createAsyncThunk(
    "productTag/update-tag",
    async (tag, thunkAPI) => {
        try {
            return await tagService.updateproductTag(tag);
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const deleteTag = createAsyncThunk(
    "productTag/delete-tag",
    async (id, thunkAPI) => {
        try {
            return await tagService.deleteTag(id);
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const getTag = createAsyncThunk(
    "productTag/get-product-tag",
    async (id, thunkAPI) => {
        try {
            return await tagService.getTag(id);
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const resetState = createAction("RevertAll");

const initialState = {
    tags: [],
    isError: false,
    isLoading: false,
    isSuccess: false,
    message: "",
};

export const tagSlice = createSlice({
    name: "tags",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getTags.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getTags.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.isSuccess = true;
                state.tags = action.payload;
            })
            .addCase(getTags.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.isSuccess = false;
                state.message = action.error;
            })
            .addCase(createTag.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(createTag.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.isSuccess = true;
                state.createdTag = action.payload;
            })
            .addCase(createTag.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.isSuccess = false;
                state.message = action.error;
            })
            .addCase(updateTag.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateTag.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.isSuccess = true;
                state.updatedTag = action.payload;
            })
            .addCase(updateTag.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.isSuccess = false;
                state.message = action.error;
            })
            .addCase(deleteTag.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deleteTag.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.isSuccess = true;
                state.deletedTag = action.payload;
            })
            .addCase(deleteTag.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.isSuccess = false;
                state.message = action.error;
            })
            .addCase(getTag.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getTag.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.isSuccess = true;
                state.tagName = action.payload.title;
            })
            .addCase(getTag.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.isSuccess = false;
                state.message = action.error;
            })
            .addCase(resetState, () => initialState);
    },
});

export default tagSlice.reducer;
